"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PriceCodeRule_1 = require("../model/PriceCodeRule");

var PriceCodeSettings_1 = require("../model/PriceCodeSettings");

var PriceCodeSettingsConverter_1 = require("./PriceCodeSettingsConverter");
/**
 * Implementation of {@link PriceCodeSettingsConverter}.
 *
 * @author Radek Beran
 */


var PriceCodeSettingsConverterImpl =
/*#__PURE__*/
function (_PriceCodeSettingsCon) {
  _inherits(PriceCodeSettingsConverterImpl, _PriceCodeSettingsCon);

  function PriceCodeSettingsConverterImpl() {
    _classCallCheck(this, PriceCodeSettingsConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceCodeSettingsConverterImpl).apply(this, arguments));
  }

  _createClass(PriceCodeSettingsConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new PriceCodeSettings_1.PriceCodeSettings(source.priceCode, conversions.toClassReferenceId(source.priceCodeId), conversions.asEnumOpt(source.priceCodeRule, PriceCodeRule_1.PriceCodeRule), source.rulePriority);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        priceCode: source.priceCode,
        priceCodeId: conversions.toDocumentReferenceId(source.priceCodeId),
        priceCodeRule: source.priceCodeRule !== null ? source.priceCodeRule.toString() : null,
        rulePriority: source.rulePriority
      });
      return result;
    }
  }]);

  return PriceCodeSettingsConverterImpl;
}(PriceCodeSettingsConverter_1.PriceCodeSettingsConverter);

exports.PriceCodeSettingsConverterImpl = PriceCodeSettingsConverterImpl;